// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-rise -> weidner-apartment-homes-weidner-classic-theme -> tower-one-two
// Generated: 2026-11-03T21:12:01.559Z
// Counts: 0 design, 26 content, 35 slot group, 2 collection binding, 10 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_short_description"
  },
  "rentcafe-chatbot.background_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "tabbedcallouts.panel1_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_gallery_blurb"
  },
  "tabbedcallouts.panel2_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "tabbedcallouts.panel3_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities &amp; Luxuries</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "floorplanslist.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_short_description"
  },
  "header.company_name": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_name"
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Building View</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "luxurydefinition.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_gallery_blurb"
  },
  "neighborhoodmap.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>High-Rise Sophistication in the Heart of Downtown <span data-type=\"field-token\" data-field=\"property_address_city\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span>, we’re not just pet-friendly, we LOVE pets and show it by providing a fenced-in pet exercise area, always having treats in the office and hosting frequent Yappy Hours…</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "footer.phone": {
    "overrideType": "VALUE",
    "customValue": "(206) 709-5400",
    "generatedValue": null,
    "mappedField": null
  },
  "header.phone": {
    "overrideType": "VALUE",
    "customValue": "(206) 709-5400",
    "generatedValue": null,
    "mappedField": null
  },
  "penthouse.featureList": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<ul><li>Waterfall quartz countertops</li><li>Full stainless steel appliance package</li><li>Deluxe six-burner gas range</li><li>Instant hot-water dispenser</li><li>Wine refrigerator (select homes)</li><li>Kitchen island with pantry</li><li>Deep soaking tub and glass-enclosed shower</li><li>Designer tile and soft-close drawers</li><li>Custom California walk-in closets</li><li>Wide-plank hardwood-style flooring</li><li>Vaulted ceilings with floor-to-ceiling windows</li><li>Private balcony with Puget Sound views (select homes)</li><li>Solar shades and central AC and heating</li><li>Full-size washer and dryer</li></ul>",
    "mappedField": null
  },
  "petpolicy.dogs_restrictions": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<ul><li>Pit Bull &amp; Pit Bull Mixes</li><li>American Pit Bull Terrier</li><li>American Staffordshire Terrier</li><li>Wolf Hybrids</li><li>Doberman Pinscher</li><li>Saint Bernard</li></ul><ul><li>American Bulldog</li><li>Staffordshire Bull Terrier</li><li>German Shepherd</li><li>Chow Chow</li><li>Great Dane</li><li>Akita</li></ul>",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.qualifying_criteria_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/company/5726763346821120/01a0edf8-50e1-766e-be36-fe17d735f389.pdf"
      }
    }
  },
  "specialofferbanner.cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "accessibility-hero.bg_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "amenitieslist.apartmentPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-25a2-7739-88eb-cd3533621ca5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with island, bar stools, and stainless steel appliances."
      }
    }
  },
  "amenitieslist.apartmentPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-bcb5-77be-bff1-b6fff070957f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with large window overlooking city skyline"
      }
    }
  },
  "amenitieslist.apartmentPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-d80d-737f-88da-a8ca160cd8fd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern bathroom with double vanity, soaking tub, and glass-enclosed shower."
      }
    }
  },
  "amenitieslist.apartmentPhoto4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-8f83-767f-9ab8-74e6db64ec2d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with large windows and city view."
      }
    }
  },
  "amenitieslist.communityPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03c73-d266-7113-be54-a651322c922a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor lounge area with fireplace, seating and tables"
      }
    }
  },
  "amenitieslist.communityPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03750-e481-7508-974f-147682453ac5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Rooftop patio with fire pit, lounge seating, and city skyline views."
      }
    }
  },
  "amenitieslist.communityPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03750-ec2f-752b-ae98-210247dbb062.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Billiard table and foosball table in a modern community lounge with kitchen area and TV."
      }
    }
  },
  "amenitieslist.communityPhoto4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03c73-d196-778f-9f74-decc6a2652f7.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fitness center with treadmills, weight machines, and large windows overlooking the water."
      }
    }
  },
  "apply-now-hero.bg_image": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "contact-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a0f463-d8ee-7378-916e-60341c08183b.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A focused close-up of a female hand holding a smartphone indoors with a soft background."
      }
    }
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "floor-plans-layout-hero.bg_image": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "frc-hero.bg_image": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[2].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[2].image_media.alt_text"
      }
    }
  },
  "interactive-leasing-map-hero.bg_image": {
    "sourceIndex": 20,
    "fieldOverrides": null
  },
  "interactive-map-hero.bg_image": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "luxurydefinition.propertygraphic": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[4].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[4].image_media.alt_text"
      }
    }
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "penthouse-hero.bg_image": {
    "sourceIndex": 20,
    "fieldOverrides": null
  },
  "penthouse.photo1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-8f6c-71ff-bbd8-85407f2fde54.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern open-concept apartment kitchen and living area with large windows and city views."
      }
    }
  },
  "penthouse.photo2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-b290-76de-8e56-d47371541f8b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious living room with large windows and a modern kitchen."
      }
    }
  },
  "penthouse.photo3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-bcb5-77be-bff1-b6fff070957f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with large window overlooking city skyline"
      }
    }
  },
  "penthouse.photo4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-d80d-737f-88da-a8ca160cd8fd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern bathroom with double vanity, soaking tub, and glass-enclosed shower."
      }
    }
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a0f462-91f0-732e-8cde-bf83d8af6abd.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A fluffy dog peacefully resting on a bed with a wooden headboard in a cozy indoor setting."
      }
    }
  },
  "privacy-policy-hero.bg_image": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "reviews-hero.bg_image": {
    "sourceIndex": 20,
    "fieldOverrides": null
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "sitemap-hero.bg_image": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 13,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.allItems": {
    "limit": null,
    "hiddenIds": [
      "ec_c28051326896a756647863bd",
      "ec_ded59bb9a0375d9febad7903",
      "ec_9fc6805fddf4393c15b5c350",
      "ec_ab9a017d57c04d63031d493d",
      "ec_3964bf418c28f86b40e4aa1b",
      "ec_f23a8da76f3331668baa1bfd",
      "ec_a783f2e4b0a3dab4df232a63",
      "ec_e6d149baaa8f3447d5ea9ad2",
      "ec_a137d0686cf58a038ba0beac",
      "ec_cf27e978c97dd08e58fd87e9",
      "ec_f6ff0cca24c3602eebbdf4b7",
      "ec_b82b05beefef3783f71a8b79",
      "ec_14b166ec140c64b7a920caf5",
      "ec_57ab129c6c30c68b333298ac",
      "ec_99b1665d08bc223f7a7bc0f9",
      "ec_a6ca1930fb131e3b674f9166",
      "ec_81abe1600c7b9c601cfddde9",
      "ec_e8b08d8f081071e6bb24762b",
      "ec_68894fac5cb07d19180e9451",
      "ec_b05d060ca39b3882489cec59",
      "ec_dd73e0a2d21a8f2b89a6c8a0",
      "ec_9db0ac7d55c2a198635a7119",
      "ec_e067a4572a76ab5aeb0f726e",
      "ec_ad3581b2efcd97154bf0ffc3",
      "ec_c03f2e3327a9f0831956b1dd",
      "ec_d0f179d6e342e888258e8098",
      "ec_0cf145fcd35acd8fa817b835",
      "ec_15e889641f2b5467787af5e7"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.apartmentItems": {
    "limit": null,
    "hiddenIds": [
      "ec_45f564c1d54ec5741a860ca6",
      "ec_41155fddc0ae9a27bb176fdf",
      "ec_347c15de1a1f00708f0fbb2b",
      "ec_2944a0c824d7965cdbf0178e",
      "ec_5bddceb1871538e8fb59fae4",
      "ec_5aed7814cbfd9977cee169e1",
      "ec_c955aa470216d34de0681ccb",
      "ec_f65ced23cf25c6fbc1128ac9",
      "ec_532cef600c3db90d21986d70",
      "ec_baeb9fef70d8747431f366bb",
      "ec_bf4e42eb6296fca4b4e4b7fa",
      "ec_274c427213b5eec67dcc85e9",
      "ec_d5c6c97be9ffa85327b1a908",
      "ec_fb1678fcecbb374a688cceb8",
      "ec_502154ac6de61fd8561057fd",
      "ec_2b0ee4328211a23eb4da7ace",
      "ec_33d646cf5cbc6d5c8413c1b6",
      "ec_952a2a235cac7971cba4f6b2",
      "ec_b37fae6b9694b7a84739d7ac",
      "ec_c0b604f8c345e2eff3dad0a7",
      "ec_dd629f1efa5ca242a4acc2cb",
      "ec_dee3088ce231e8fbd9d52090",
      "ec_83ad20fbd903ac6e8b9450d6",
      "ec_88710a1495ed155a74518c77",
      "ec_a1542600f965cd3bcfbefd1e",
      "ec_c3f730016aa088bdfb251a24",
      "ec_a5cfd87a34536ce5b5645720",
      "ec_1e984947befa88b1fc073b6b",
      "ec_7cfcefc5212fa1821eca180a",
      "ec_421e9beb151668bf7f0fe54a",
      "ec_37403f70139638173b400875",
      "ec_e30d5e3e9a153e6875dd3a18",
      "ec_f6338538fa4010e4aac2ec35",
      "ec_ee7ad3a47ec3869b11d18898",
      "ec_19686317e93c4058978dc3a0",
      "ec_5f32f54c7954e31c75785ac9",
      "ec_651d58e462143c6e9a889cb1",
      "ec_4115e44ae585386e0cd2386f",
      "ec_304c67c5ff7d02ef6c324cf2",
      "ec_a4045677eb54ca16795ef299",
      "ec_c28051326896a756647863bd",
      "ec_ded59bb9a0375d9febad7903",
      "ec_9fc6805fddf4393c15b5c350",
      "ec_ab9a017d57c04d63031d493d",
      "ec_3964bf418c28f86b40e4aa1b",
      "ec_f23a8da76f3331668baa1bfd",
      "ec_a783f2e4b0a3dab4df232a63",
      "ec_e6d149baaa8f3447d5ea9ad2",
      "ec_a137d0686cf58a038ba0beac",
      "ec_cf27e978c97dd08e58fd87e9",
      "ec_14b166ec140c64b7a920caf5",
      "ec_f6ff0cca24c3602eebbdf4b7",
      "ec_b82b05beefef3783f71a8b79",
      "ec_57ab129c6c30c68b333298ac",
      "ec_99b1665d08bc223f7a7bc0f9",
      "ec_a6ca1930fb131e3b674f9166",
      "ec_81abe1600c7b9c601cfddde9",
      "ec_68894fac5cb07d19180e9451",
      "ec_b05d060ca39b3882489cec59",
      "ec_e8b08d8f081071e6bb24762b",
      "ec_dd73e0a2d21a8f2b89a6c8a0",
      "ec_9db0ac7d55c2a198635a7119",
      "ec_e067a4572a76ab5aeb0f726e",
      "ec_ad3581b2efcd97154bf0ffc3",
      "ec_c03f2e3327a9f0831956b1dd",
      "ec_d0f179d6e342e888258e8098",
      "ec_0cf145fcd35acd8fa817b835",
      "ec_a8f001a725fe63e98b561c7c",
      "ec_acbf24278214160f32cc77af",
      "ec_4e2e371d6f99d123ac8a3c49",
      "ec_cfdb0cd056a6cc85c88073ca",
      "ec_3a3306ff22a5636abd41c10e",
      "ec_80814d12a071724ed71aed40",
      "ec_15e889641f2b5467787af5e7",
      "ec_16dad781d49df72a9adfbe64",
      "ec_bad316c8cd838b50c6d8b778",
      "ec_ec88b409a685d6a67b763d21",
      "ec_0f8d01d52b11592fedc55531",
      "ec_9985777bed7b8935762019f3",
      "ec_fadb4a9bc0524e7581243188",
      "ec_81b1b45c38ca7b5f81f6529b",
      "ec_50e8ff0576db472f3df66c49",
      "ec_25ea843879ee5a1905c09256",
      "ec_4ad9de2de5d7da0a463dc8ae",
      "ec_5f437b45d76da818615c6167",
      "ec_55423d9eeb9419b5437d3a40",
      "ec_b4eedf8728aa4351ec6244ec",
      "ec_51020191c5e0568c082b5f07",
      "ec_4c85adfc91c36e6e3a61e65e",
      "ec_e1048543416c24188ca677da",
      "ec_8d95dceba8686010b8ac45df",
      "ec_4c755d0737efa64d0dfae6af",
      "ec_4865a8ab188ab3fe7e66411b"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ],
  "interactive-leasing-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 10
    }
  ]
};

export const styleOverrides = {};
